import ApiService from '@/api/api_service';
import {
  SalesforceSettingsApi,
} from '@/api/openapi';

export class SfSalesforceSettingsService extends ApiService {
  api = new SalesforceSettingsApi(undefined, this.baseUrl, this.httpInstance);

  constructor() {
    // openapiで作ったやつはtrue
    super(true);
  }

  async updateSyncSfObject(args) {
    return this.api.putSalesforceSettingSyncSfObject({ putSalesforceSettingSyncSfObjectRequest: args });
  }
}
